import { ShopState } from "./shop.reducer";
import { Item, Collection } from "./shop.types";

// export const getCollectionsAsync = async (idList: string[]) => {
//   return Promise.all(idList.map((id) => getCollection(id)));
// };

export const transformCollection = (collection: any) => {
  let transformedCollection: Collection = {
    ...collection,
    id: collection.collectionId,
    title: collection.name.replace("_", " ").replace("-", " ").toLowerCase(),
    path: collection.name.replace("_", "-").replace(" ", "-").toLowerCase(),
    collections: collection.collections
      ? Object.values(collection.collections)
      : null,
  };

  transformedCollection.collections = transformedCollection.collections?.map(
    (innerCollection) => {
      return (innerCollection = transformCollection(innerCollection));
    },
  );

  return transformedCollection;
};

export const convertCollections = (collections: any) => {
  const petCollection = collections.filter((collection: any) =>
    collection.name.toUpperCase().includes("PET"),
  )[0];

  const justInCollection = collections.filter(
    (collection: any) =>
      collection.name.toUpperCase().includes("JUST") &&
      collection.name.toUpperCase().includes("IN"),
  )[0];

  const specialCollection = collections.filter((collection: any) =>
    collection.name.toUpperCase().includes("SPECIAL"),
  )[0];

  const transformedPetCollection: Collection =
    transformCollection(petCollection);

  const transformedJustInCollection: Collection =
    transformCollection(justInCollection);

  const transformedSpecialCollection: Collection =
    transformCollection(specialCollection);

  return {
    petCollection: transformedPetCollection,
    justInCollection: transformedJustInCollection,
    specialCollection: transformedSpecialCollection,
  };
};

export const transformProducts = (products: any[]) => {
  return products
    .filter((product) => product.status === "ACTIVE")
    .map((product) => {
      const variants = product.variants.map((variant: any) =>
        transformProductOrVariant(variant),
      );

      return {
        ...transformProductOrVariant(product),
        variants,
      };
    });
};

export const transformProductOrVariant = (productOrVariant: any) => {
  let variants = [];

  if (productOrVariant.variants) {
    variants = productOrVariant.variants.map((variant: any) => ({
      ...transformProductOrVariant(variant),
      id: variant.dashboardCollection,
      title: productOrVariant.title,
      brand: productOrVariant.brand,
      isOnSale: !!variant.priceSales,
      isSoldOut: variant.quantity === 0,
      price: variant.priceSales ? variant.priceSales : variant.priceBase,
      discountRate:
        (variant.priceSales && variant.priceSales < variant.priceBase
          ? 1 - variant.priceSales / variant.priceBase
          : 0) * 100,
    }));
  }

  return {
    ...productOrVariant,
    variants,
    id: productOrVariant.dashboardCollection,
    isOnSale: !!productOrVariant.priceSales,
    isSoldOut: productOrVariant.quantity === 0,
    price: productOrVariant.priceSales
      ? productOrVariant.priceSales
      : productOrVariant.priceBase,
    discountRate:
      (productOrVariant.priceSales &&
      productOrVariant.priceSales < productOrVariant.priceBase
        ? 1 - productOrVariant.priceSales / productOrVariant.priceBase
        : 0) * 100,
  };
};
